import React from 'react';

const AboutSection = () => {
  return (
    <section className="py-5 shadow-sm" style={{ background: '#0f172a', color: '#f8fafc' }}>
      <div className="container">
        {/* On retire align-items-center pour laisser le flux naturel (texte en haut, réseaux en bas sur PC) */}
        <div className="row g-4">
          
          {/* Texte de présentation - col-12 pour occuper toute la largeur avant les réseaux */}
          <div className="col-12 col-lg-10 mx-auto text-center mb-2">
            <div className="px-lg-4">
              <h6 className="text-warning fw-black text-uppercase tracking-widest mb-2" style={{ fontSize: '24px' }}>
                Plus qu'une Radio, une Communauté
              </h6>
              <h2 className="fw-black text-uppercase italic mb-3">
                Fréquence <span className="text-danger">974</span> Studio Digital
              </h2>
              <p className="text-secondary mb-4 mx-auto" style={{ lineHeight: '1.6', maxWidth: '850px' }}>
                Émettant depuis le cœur de l'Océan Indien, nous fusionnons la passion de la radio traditionnelle 
                avec la puissance du digital. Retrouvez le meilleur du son local, les interviews exclusives 
                et vos hits préférés 24h/24. 
              </p>
            </div>
          </div>

          {/* Réseaux Sociaux - Positionnés en dessous grâce au flux col-12 */}
          <div className="col-12 col-md-8 col-lg-6 mx-auto">
            <div className="p-4 rounded-5 bg-black bg-opacity-50 border border-secondary border-opacity-25 shadow-lg">
              <p className="fw-black text-uppercase text-center mb-4" style={{ fontSize: '13px', letterSpacing: '1px' }}>
                Suivez l'aventure en direct
              </p>
              
              <div className="d-flex flex-column gap-3">
                {/* Facebook centré */}
                <a href="https://www.facebook.com/profile.php?id=100094076973341" target="_blank" rel="noreferrer" 
                   className="btn btn-primary d-flex align-items-center justify-content-center rounded-pill px-4 py-3 transition-all hover-translate">
                  <div className="d-flex align-items-center">
                    <i className="bi bi-facebook fs-5 me-3"></i>
                    <span className="fw-bold small text-uppercase">Facebook</span>
                  </div>
                </a>

                {/* Instagram (Toujours présent en commentaire comme demandé) */}
                {/*}
                <a href="https://instagram.com" target="_blank" rel="noreferrer" 
                   className="btn d-flex align-items-center justify-content-center rounded-pill px-4 py-3 text-white transition-all hover-translate"
                   style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                  <div className="d-flex align-items-center">
                    <i className="bi bi-instagram fs-5 me-3"></i>
                    <span className="fw-bold small text-uppercase">Instagram</span>
                  </div>
                </a>
                */}

                {/* TikTok centré */}
                <a href="https://www.tiktok.com/@frekens974?lang=fr" target="_blank" rel="noreferrer" 
                   className="btn btn-light d-flex align-items-center justify-content-center rounded-pill px-4 py-3 transition-all hover-translate">
                  <div className="d-flex align-items-center text-dark">
                    <i className="bi bi-tiktok fs-5 me-3"></i>
                    <span className="fw-bold small text-uppercase">TikTok</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <style>{`
        .fw-black { font-weight: 900; }
        .italic { font-style: italic; }
        .hover-translate:hover {
          transform: translateY(-5px);
          filter: brightness(1.1);
        }
        .transition-all { transition: all 0.3s ease; }
      `}</style>
    </section>
  );
};

export default AboutSection;